<template>
  <div
    class="avatar-box m-2 d-flex justify-content-center"
    v-if="avatar.id"
    :data-cy="`avatar-image${avatar.id}-component`"
  >
    <div
      :id="'avatar-' + (avatar.active ? 'active' : 'store') + '-' + avatar.id"
      class="avatar-image position-relative d-flex justify-center align-center"
      @click="toggleActiveAvatar"
      :data-cy="`avatar-image${avatar.id}-id`"
    >
      <img
        :src="`https://assets.beeverso.org/avatar/${avatar.name}/${avatar.value}`"
        class="avatar-img transition-all"
        @load="handleLoaded"
        alt="Av"
      />
      <v-overlay absolute :value="!avatar.active" opacity="0">
        <v-row class="absolute-beecoins" justify="center" align="center">
          <v-img :src="require('@/assets/img/icons/beecoins.png')" height="50" width="50"> </v-img>
        </v-row>
      </v-overlay>
      <div
        class="pa-0 ma-0 avatar-check avatar-check-none white transition-all rounded-circle"
        :id="'avatar-check-' + (avatar.active ? 'active' : 'store') + '-' + avatar.id"
      >
        <em class="mdi mdi-36px mdi-checkbox-marked-circle purple-text transition-all pt-2"></em>
      </div>
      <v-skeleton-loader
        v-if="!loaded"
        class="rounded-circle position-absolute opacity-none"
        height="120"
        width="120"
        type="image"
        :transition="'scale-transition'"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"

export default {
  props: {
    avatar: {
      type: Object,
      default: DEFAULT_AVATAR,
    },
    selected: { type: Boolean, default: false },
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    if (this.selected) {
      this.setActiveAvatar()
    }
    setTimeout(() => {
      this.setToBuy()
    }, 500)
  },
  methods: {
    setToBuy() {
      const avatar = document.querySelector(`#avatar-store-${this.avatar.id} > img`)
      if (!this.avatar.active && avatar) {
        avatar.classList.add('avatar-to-buy')
      }
    },
    setActiveAvatar() {
      const avatar = document.querySelector(`#avatar-active-${this.avatar.id}`)
      avatar.classList.add('avatar-active')

      const check = document.querySelector(`#avatar-check-active-${this.avatar.id}`)
      check.classList.remove('avatar-check-none')
    },
    deselectOthers() {
      const avatar = document.querySelector('.avatar-active')
      if (avatar)
        avatar.classList.remove('avatar-active')

      const avatarsCheck = document.querySelectorAll('.avatar-check') || []
      if (avatarsCheck.length > 0) {
        for (let i = 0; i < avatarsCheck.length; i += 1) {
          avatarsCheck[i].classList.add('avatar-check-none')
        }
      }
    },
    toggleActiveAvatar() {
      if (!this.avatar.active) {
        this.$emit('toBuy', this.avatar)
        return
      }
      this.deselectOthers()

      const avatar = this.avatar.active
        ? document.querySelector(`#avatar-active-${this.avatar.id}`)
        : document.querySelector(`#avatar-store-${this.avatar.id}`)

      avatar.classList.add('avatar-active')

      const check = this.avatar.active
        ? document.querySelector(`#avatar-check-active-${this.avatar.id}`)
        : document.querySelector(`#avatar-check-store-${this.avatar.id}`)
      check.classList.remove('avatar-check-none')
      this.$emit('active', this.avatar.id)
    },
    handleLoaded() {
      this.loaded = true
    },
  },
}
</script>

<style lang="scss">
.avatar-box,
.avatar-image {
  border-radius: 100%;
  // overflow: hidden;
}

.avatar-active .avatar-img {
  padding: 0;
}
.avatar-img {
  border-radius: 50%;
  display: block;
  width: 100%;
}

.avatar-active {
    .avatar-img{
        background-color: #FFF;
        border-radius: 500px;
        z-index: 1;
    }
    &::after{
        content: '';
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%),
        linear-gradient(0deg, rgba(174, 236, 180, 0.3), rgba(174, 236, 180, 0.3));
        border-radius: 500px;
        display: block;
        height: 112%;
        position: absolute;
        left: -6%;
        top: -6%;
        width: 112%;
        z-index: 0;
    }
}

.avatar-check {
  bottom: 0px;
  right: -15px;
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.avatar-check-none {
  display: none;
}
.avatar-to-buy {
  opacity: 0.3;
}
.purple-text{
  color: #6857B2;
  caret-color: #6857B2;
}
.absolute-beecoins{
  bottom: -5em;
  right: -4em;
  position: absolute;
  @media screen and (max-width: 600px) {
    bottom: -4em;
    right: -3em;
  }
}
</style>
